const prjNotice = {
  state: {
    uploadTypeKey: '',
    uploadFilesData: {},
    uploadFilesArr: []
  },

  mutations: {
    PRJNOTICE_UPLOAD_TYPE(state, data) {
      state.uploadTypeKey = data;
    },
    SET_UPLOAD_FILES_DATA(state, data) {
      state.uploadFilesData = data;
    },
    SET_UPLOAD_FILES_ARR(state, data) {
      state.uploadFilesArr = data;
    }
  },
  actions: {
    prjNoticeUploadType ({ commit }, data) {
      commit('PRJNOTICE_UPLOAD_TYPE', data);
    },
    setuploadFilesData({ commit }, data) {
      commit('SET_UPLOAD_FILES_DATA', data);
    },
    setuploadFilesArr({ commit }, data) {
      commit('SET_UPLOAD_FILES_ARR', data);
    }
  }
};
export default prjNotice;
